import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

export const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    component: () => import("@/layout/index.vue"),
    redirect: "/index",
    children: [
      // layout
      {
        path: "index",
        name: "index",
        meta: {
          title: "index",
        },
        component: () => import("@/views/home/index.vue"),
      },
    ],
  },
  {
    path: "/agreement",
    name: "agreement",
    component: () => import("@/views/policy-agreement/index.vue"),
  },
  {
    path: "/club-agreement",
    name: "club-agreement",
    component: () => import("@/views/policy-club-agreement/index.vue"),
  },
  {
    path: "/light-star-agreement",
    name: "light-star-agreement",
    component: () => import("@/views/light-star-agreement/index.vue"),
  },
  {
    path: "/a1-agreement",
    name: "a1-agreement",
    component: () => import("@/views/a1-agreement/index.vue"),
  },
  {
    path: "/thai-agreement",
    name: "thai-agreement",
    component: () => import("@/views/thai-agreement/index.vue"),
  },
  {
    path: "/error",
    name: "error",
    component: () => import("@/views/error/index.vue"),
  },
  // 替代Vue2中 ‘*’ 通配符路径
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
